// @ts-check
import React from 'react';
import PropTypes from 'prop-types';
import { components, contentfulWidgets } from '@glowforge/ui-common';
import './materials-carousel-3d.less';

const { Carousel3dGallery } = components;
const { ButtonLinkWidget } = contentfulWidgets;


/**
 * @typedef {object} Carousel3dGalleryImageData
 * @property {string} id Unique id for image
 * @property {string} thumbnailUrl Thumbnail image url
 * @property {string} thumbnailTitle Title of the thumbnail
 * @property {string} heroUrl Hero image url
 * @property {string} description Description of the large image
 */

/**
 * @typedef {object} CtaProps
 * @property {string} id
 * @property {string} internalName
 * @property {string} size
 * @property {string} text
 * @property {string} type
 * @property {string} url
 */

/**
 * @typedef {object} Props
 * @property {Carousel3dGalleryImageData[]} data
 * @property {string} title
 * @property {string} text
 * @property {CtaProps} ctaProps
 */

/**
 * @class
 * @extends {React.PureComponent<Props>}
 */
class MaterialsCarousel3d extends React.PureComponent {
  static itemShape = PropTypes.shape({
    id: PropTypes.string,
    thumbnailTitle: PropTypes.string.isRequired,
    thumbnailUrl: PropTypes.string.isRequired,
    heroUrl: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
  });

  static propTypes = {
    data: PropTypes.arrayOf(MaterialsCarousel3d.itemShape).isRequired,
    title: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    ctaProps: PropTypes.shape({
      id: PropTypes.string.isRequired,
      internalName: PropTypes.string.isRequired,
      size: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    }).isRequired,
  }

  render() {
    const {
      data,
      title,
      text,
      ctaProps,
    } = this.props;

    const learnMoreButton = (
      <ButtonLinkWidget
        model={{ fields: ctaProps }}
        key='ctaButton'
        className='ctaButton' />
    );

    return (
      <div className='MaterialsCarousel3d'>
        <h2 className='title'>{title}</h2>
        <Carousel3dGallery data={data} thumbnailWidth={160} thumbnailHeight={160} />
        <p className='text'>{text}</p>
        {learnMoreButton}
      </div>
    );
  }
}

export default MaterialsCarousel3d;



// WEBPACK FOOTER //
// ./app/components/landing/materials-carousel-3d.jsx